import {
  faCalendarDays,
  faCogs,
  faFlag,
  faScrewdriverWrench,
  faToolbox,
  faUserCog,
} from "@fortawesome/free-solid-svg-icons";
import createField from "../../../utils/factory/createField";

export const filterFields = [
  {
    section: "Filtros para o relatório",
    fields: [
      createField({
        id: "filter.start_date",
        label: "Periodo de manutenção de",
        placeholder: "Selecione o periodo de inicio",
        type: "date",
        icon: faCalendarDays,
      }),
      createField({
        id: "filter.end_date",
        label: "Periodo de manutenção até",
        placeholder: "Selecione o periodo de fim",
        type: "date",
        icon: faCalendarDays,
      }),
      createField({
        id: "filter.technician_id",
        label: "Técnico",
        type: "select",
        placeholder: "Selecione o técnico",
        isClearable: true,
        icon: faUserCog,
      }),
      createField({
        id: "filter.type_id",
        label: "Tipo do equipamento",
        placeholder: "Selecione o tipo do equipamento",
        type: "select",
        isClearable: true,
        icon: faToolbox,
      }),
      createField({
        id: "filter.maintenance_type_id",
        label: "Tipo de Manutenção",
        placeholder: "Selecione o tipo de manutenção",
        type: "select",
        isClearable: true,
        icon: faScrewdriverWrench,
      }),
      createField({
        id: "filter.technician_status_id",
        label: "Situação",
        placeholder: "Selecione a situação",
        type: "select",
        isClearable: true,
        icon: faFlag,
      }),
      createField({
        id: "filter.equipment_id",
        label: "Equipamento",
        placeholder: "Selecione o equipamento",
        type: "select",
        fullWidth: true,
        isClearable: true,
        icon: faCogs,
      }),
    ],
  },
];
